// Third party packages
import { throwError } from "rxjs";
import { catchError } from "rxjs/operators";
// Custom packages
import { TranslateService } from "@ngx-translate/core";
import { ApiService } from "src/app/shared/services/api.service";
import { HelperService } from "src/app/shared/services/helper.service";
import * as i0 from "@angular/core";
import * as i1 from "../../shared/services/api.service";
import * as i2 from "../../shared/services/helper.service";
import * as i3 from "@ngx-translate/core";
var InvoicesService = /** @class */ (function () {
    /**
     * Class constructor
     */
    function InvoicesService(apiService, helperService, translateService) {
        this.apiService = apiService;
        this.helperService = helperService;
        this.translateService = translateService;
    }
    /**
     * Create a new invoice
     *
     * @since 1.0.0
     *
     * @param invoice Invoice data
     * @returns Observable<any>
     */
    InvoicesService.prototype.create = function (invoice) {
        return this.apiService.apiCall("POST", "invoices", invoice);
    };
    /**
     * Get invoices list for given query params
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    InvoicesService.prototype.getList = function (start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall("GET", "invoices", params);
    };
    /**
     * Get an exportation file of invoices
     *
     * @since 1.0.0
     */
    InvoicesService.prototype.getExport = function (balanceNumber) {
        var _this = this;
        return this.apiService
            .apiCall("GET", "invoices/export/" + balanceNumber, {}, { responseType: "blob" })
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get given invoiceId data from back-end
     *
     * @since 1.0.0
     *
     * @param invoiceId ID of the balance to get
     */
    InvoicesService.prototype.get = function (invoiceId) {
        var _this = this;
        return this.apiService.apiCall("GET", "invoices/" + invoiceId).pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Update invoice with given invoiceId with given invoice data
     *
     * @since 1.0.0
     *
     * @param invoiceId ID of invoice to update
     * @param data New balance's data
     */
    InvoicesService.prototype.updateFields = function (invoiceId, data) {
        return this.apiService.apiCall("PATCH", "invoices/" + invoiceId, data);
    };
    /**
     * Delete permanently a invoice
     *
     * @since 1.0.0
     *
     * @param invoiceId ID of the invoice
     */
    InvoicesService.prototype.delete = function (invoiceId) {
        return this.apiService.apiCall("DELETE", "invoices/" + invoiceId);
    };
    InvoicesService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function InvoicesService_Factory() { return new InvoicesService(i0.ɵɵinject(i1.ApiService), i0.ɵɵinject(i2.HelperService), i0.ɵɵinject(i3.TranslateService)); }, token: InvoicesService, providedIn: "root" });
    return InvoicesService;
}());
export { InvoicesService };
